<template>
  <!-- Dashboard Content
	================================================== -->
  <div class="dashboard-content-container" data-simplebar>
    <div class="dashboard-content-inner">
      <!-- Dashboard Headline -->
      <div class="dashboard-headline">
        <h3>{{ PAGE_NAME }}</h3>

        <!-- Breadcrumbs -->
        <nav id="breadcrumbs" class="dark">
          <ul>
            <li><a href="#">Home</a></li>
            <li><a href="#">Dashboard</a></li>
            <li>{{ PAGE_NAME }}</li>
          </ul>
        </nav>
      </div>

      <!-- Row -->
      <div class="row">
        <user-security-question></user-security-question>

        <update-user-security></update-user-security>

        <update-user-skill></update-user-skill>

        <user-location></user-location>
      </div>
      <!-- Row / End -->

      <!-- Footer -->
      <app-footer></app-footer>
      <!-- Footer / End -->
    </div>
  </div>
  <!-- Dashboard Content / End -->
</template>

<script>
import { AppFooter } from "../../partials/user-dashboard";
import UserSetSecurityQuestion from "./SetSecurityQuestion.vue";
import UpdateUserSecurityData from "./UpdateUserSecurityData.vue";
import UpdateUserSkill from "./UpdateUserSkill.vue";
import UserLocation from "./UserLocation.vue";

const PAGE_NAME = "Settings";
export default {
  name: "UserSettings",
  components: {
    "app-footer": AppFooter,
    "user-security-question": UserSetSecurityQuestion,
    "update-user-security": UpdateUserSecurityData,
    "update-user-skill": UpdateUserSkill,
    "user-location": UserLocation,
  },
  data() {
    return {
      PAGE_NAME,
    };
  },
};
</script>

<style></style>
